"use client";

import { ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PracticeAreas() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    title: "ビジネス",
    description: "会社設立、LLCのOperating Agreement、CorporationのShareholders’ AgreementやBylaws、契約書の作成・レビュー、事業の購入・売却など。"
  }, {
    title: "不動産取引",
    description: "住宅および商業不動産の購入・売却、契約書、リース、Title、Closing、Due Diligenceなど。"
  }, {
    title: "遺言・信託・プロベート",
    description: "遺言、信託、Health Care関連文書、財産の名義、受益者指定、Probateに関する手続きなど。"
  }, {
    title: "弁護士費用",
    description: "弁護士費用やコストに関する請求について、作業内容、所要時間、Work Product、Reasonable Hourly Rateなどを検討する案件。"
  }];
  return <section data-section-id="241" id="practiceareasgridjapanese" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="container mx-auto px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-sans uppercase tracking-widest text-xs text-primary font-medium">
                取扱分野
              </span>
            </div>
            <h2 className="font-default font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-primary">
              南フロリダで取り扱う主な法律分野
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-md lg:ml-auto">モーリー・I・レヴィーン弁護士は、南フロリダを中心に、ビジネス、不動産取引、遺言・信託・プロベート、弁護士費用に関する案件を取り扱っています。</p>
          </div>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border/60 border border-border/60">
          {services.map((service, i) => {
          return <div key={i} data-index={i} className={`group relative bg-card p-8 md:p-12 border border-transparent transition-all duration-300 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
          }}>
                {}
                <h3 className="font-default font-serif text-2xl font-normal text-foreground mb-4 leading-snug">
                  {service.title}
                </h3>

                {}
                <p className="text-sm md:text-base leading-relaxed text-muted-foreground">
                  {service.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div ref={ctaRef} className={`mt-16 md:mt-20 text-center transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild variant="link" className="text-foreground hover:text-primary font-mono uppercase tracking-wider text-sm h-auto p-0">
            <Link to="/ContactUsPage" className="inline-flex items-center gap-2 group">
              <span className="border-b border-border group-hover:border-primary pb-1 transition-colors duration-300">
                Schedule a consultation
              </span>
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}